<template>
  <section class="releaseLogDiv">
    <viewTitle title="业务管理 / 车辆安全放行 / 放行日志" :showReturn="false" />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <!-- <el-radio-group
          v-model="params.radioTime"
          @change="radioChange"
          size="small"
          fill="#2acdcf"
          style="vertical-align: bottom;margin-right: 35px;"
        >
          <el-radio-button label="前天"></el-radio-button>
          <el-radio-button label="昨天"></el-radio-button>
          <el-radio-button label="今天"></el-radio-button>
        </el-radio-group> -->
        <el-date-picker
          v-model="params.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="操作开始日期"
          end-placeholder="操作结束日期"
          :picker-options="pickerOptions"
          @change="changeTimeRange"
        >
        </el-date-picker>
        <el-input
          style="width: 20% !important;margin: 0px 35px;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button type="primary" @click="refreshData" size="small">
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column prop="user_name" label="操作人" width="240">
        </el-table-column>
        <el-table-column prop="note" label="操作内容"> </el-table-column>
        <el-table-column label="操作时间" width="280">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        radioTime: "今天", // radio默认选择的时间
        time: [], // timepicker时间
        begin_time: "",
        end_time: ""
      },
      maxSize: 0,
      tableData: [], // 表格数据
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mixins: [mixinTableLyout],

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    this.params.time.push(
      moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD")
    );
    this.params.time.push(
      moment()
        .startOf("day")
        .format("YYYY-MM-DD")
    );
    this.params.begin_time = moment(this.params.time[0]).unix();
    this.params.end_time = moment()
      .endOf("day")
      .unix();
    this.getList();
  },

  async activated() {},

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 选择时间范围
    changeTimeRange() {
      if (this.params.time === null) {
        this.params.begin_time = "";
        this.params.end_time = "";
      } else {
        this.params.begin_time = moment(this.params.time[0]).unix();
        this.params.end_time = moment(this.params.time[1]).unix() + 86399;
      }
      this.page = 1;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_release_log",
        data: {
          date: "",
          begin_time: this.params.begin_time,
          end_time: this.params.end_time,
          keyword: this.params.keyword,
          page_size: this.pageSize,
          page: this.page
        }
      });
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 44; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 200; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.releaseLogDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 129px);
    position: relative;
  }
}
.page-wrap {
  margin-top: 10px;
}
</style>
